module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px",
      "height": "auto !important"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Assignment Report Details")]), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  })], 1), _vm._v(" "), _c('b-card', [_c('span', {
    staticClass: "error"
  }, [_vm._v("Only 1 Month Data Filter Apply in Date Field")]), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('date-range-picker', {
    staticClass: "mt-2",
    attrs: {
      "opens": _vm.openRight,
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-input', {
    staticClass: "mt-2",
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": " Assignment No."
    },
    model: {
      value: (_vm.assignmentFilter),
      callback: function($$v) {
        _vm.assignmentFilter = $$v
      },
      expression: "assignmentFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('model-list-select', {
    staticClass: "mt-2",
    attrs: {
      "list": _vm.clientMaster,
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select  Client Name"
    },
    on: {
      "input": _vm.ClientDrag
    },
    model: {
      value: (_vm.clientIdFilter),
      callback: function($$v) {
        _vm.clientIdFilter = $$v
      },
      expression: "clientIdFilter"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('model-list-select', {
    staticClass: "mt-2",
    attrs: {
      "list": _vm.jobList,
      "option-value": "jv",
      "option-text": "jt",
      "placeholder": " JobType"
    },
    model: {
      value: (_vm.jobTypeFilter),
      callback: function($$v) {
        _vm.jobTypeFilter = $$v
      },
      expression: "jobTypeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('model-list-select', {
    staticClass: "mt-2",
    attrs: {
      "list": _vm.finalAllPlaceDataPOR,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Place of Receipt"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOR')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOR')
      }
    },
    model: {
      value: (_vm.PORfilter),
      callback: function($$v) {
        _vm.PORfilter = $$v
      },
      expression: "PORfilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('model-list-select', {
    staticClass: "mt-2",
    attrs: {
      "list": _vm.finalAllPlaceDataPOD,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Port of Discharge"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOD')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOD')
      }
    },
    model: {
      value: (_vm.PODfilter),
      callback: function($$v) {
        _vm.PODfilter = $$v
      },
      expression: "PODfilter"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('model-list-select', {
    staticClass: "mt-2",
    attrs: {
      "list": _vm.finalAllPlaceDataLP,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Load Port"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataLP')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataLP')
      }
    },
    model: {
      value: (_vm.LPfilter),
      callback: function($$v) {
        _vm.LPfilter = $$v
      },
      expression: "LPfilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('model-list-select', {
    staticClass: "mt-2",
    attrs: {
      "list": _vm.shippingList,
      "option-value": "shippingId",
      "option-text": "shippingLine",
      "placeholder": "Select Shipping Line"
    },
    model: {
      value: (_vm.shippingFilter),
      callback: function($$v) {
        _vm.shippingFilter = $$v
      },
      expression: "shippingFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('model-list-select', {
    staticClass: "mt-2",
    attrs: {
      "list": _vm.branchList,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": " Branch"
    },
    model: {
      value: (_vm.branchfilter),
      callback: function($$v) {
        _vm.branchfilter = $$v
      },
      expression: "branchfilter"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('model-list-select', {
    staticClass: "mt-2",
    attrs: {
      "list": _vm.SOBStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select SOB Status"
    },
    model: {
      value: (_vm.SOBFilter),
      callback: function($$v) {
        _vm.SOBFilter = $$v
      },
      expression: "SOBFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-input', {
    staticClass: "mt-2",
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": " Container No."
    },
    model: {
      value: (_vm.containerNoFilter),
      callback: function($$v) {
        _vm.containerNoFilter = $$v
      },
      expression: "containerNoFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "4",
      "center": ""
    }
  }, [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.filterSearch
    }
  }, [_vm._v("Search")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-3",
    attrs: {
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("clear")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Download Excel' ? true : false,
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.getReportsAss('MainAssignment_SCREEN')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.ExcelBtnName) + "\n                "), (_vm.ExcelBtnName != 'Download Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.clientData) ? _c('b-button', {
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "size": "sm",
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.goToDrag(_vm.clientData)
      }
    }
  }, [_vm._v("Clients Excell Temp")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (_vm.addEditCard) ? _c('b-card', {
    staticClass: "mt-4"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('h5', [_vm._v("Excel Column")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "10"
    }
  }, [_c('div', {
    staticClass: "checkbox-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isCheckAll),
      expression: "isCheckAll"
    }],
    staticClass: "styled-checkbox",
    attrs: {
      "id": "SelectAll",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isCheckAll) ? _vm._i(_vm.isCheckAll, null) > -1 : (_vm.isCheckAll)
    },
    on: {
      "click": function($event) {
        _vm.selectAll()
      },
      "change": function($event) {
        var $$a = _vm.isCheckAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isCheckAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isCheckAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isCheckAll = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Select / Deselect All Count(" + _vm._s(this.selectedItems.length) + ")")])])])], 1), _vm._v(" "), (_vm.ExcelItems.length > 0) ? _c('b-row', _vm._l((_vm.ExcelItems), function(item, index) {
    return _c('b-col', {
      key: index,
      attrs: {
        "md": "2"
      }
    }, [_c('div', {
      staticClass: "checkbox-container"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedItems),
        expression: "selectedItems"
      }],
      key: index,
      staticClass: "styled-checkbox",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": item.id,
        "checked": Array.isArray(_vm.selectedItems) ? _vm._i(_vm.selectedItems, item.id) > -1 : (_vm.selectedItems)
      },
      on: {
        "click": _vm.select,
        "change": function($event) {
          var $$a = _vm.selectedItems,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedItems = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedItems = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedItems = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', [_vm._v(_vm._s(item.name))])])])
  })) : _vm._e(), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "text-center ml-auto mr-auto"
  })])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', [_c('b-pagination', {
    staticClass: "mt-3",
    staticStyle: {
      "margin": "0px"
    },
    attrs: {
      "limit": "5",
      "align": "right",
      "per-page": _vm.perPage,
      "total-rows": _vm.totalRows
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1), _vm._v(" "), _c('h5', {
    staticClass: "text-muted pull-right mt-2 ml-3"
  }, [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.totalRows) + " Entries")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain gutr"
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.consoBooking,
      "fields": _vm.fields,
      "per-page": _vm.perPage,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "jobType",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: "mainSalesSeries",
      fn: function(row1) {
        return [_c('md-icon', [_vm._v(_vm._s(row1.item.shipmentType == "1" ||
          row1.item.shipmentType == "Sea_Shipment" ?
          "directions_boat" :
          "flight_takeoff"))]), _vm._v(" "), _c('b', [_vm._v(_vm._s(row1.item.mainSalesSeries))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("\n                " + _vm._s(row1.item.jobType) + " (" + _vm._s(row1.item.shipmentType == "1" ||
          row1.item.shipmentType == "Sea_Shipment" ?
          "Sea" :
          "Air") + "\n                " + _vm._s(row1.item.transportType) + ")")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Assignment Dt. : " + _vm._s(_vm._f("moment")(row1.item.assignmentDate)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Raised From : " + _vm._s(row1.item.raisedFrom)), _c('br')]), _vm._v(" "), _c('span', [_vm._v(" By : " + _vm._s(row1.item.raisedBy))]), _vm._v(" "), _c('br'), _vm._v(" "), (row1.item.sob_date != '' && row1.item.sob_date != null) ? _c('span', [_c('b', {
          style: ('color:black')
        }, [_vm._v("SOB : " + _vm._s(row1.item.sob_date))]), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_c('b', [_vm._v("SAILED")])])], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('b-button', {
          staticClass: "mt-2",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": function($event) {
              _vm.showDocModal(row1.item)
            }
          }
        }, [_vm._v("Summary & Documents")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('Assignment-Summary', {
          attrs: {
            "title": 'Shipment Summary Tracking - ',
            "fk_all_module_id": row1.item.allModuleId,
            "jb_series": row1.item.mainSalesSeries
          }
        }), _vm._v(" "), (row1.item.splitFromId != '0') ? _c('h7', {
          staticClass: "mt-2"
        }, [_c('b-badge', {
          attrs: {
            "variant": "info"
          }
        }, [_vm._v("Split of " + _vm._s(row1.item.splitFromNo))])], 1) : _vm._e()]
      }
    }, {
      key: "TPTClient",
      fn: function(row11) {
        return [(
          row11.item.clientType == '3' && row11.item.transportType == 'Export'
        ) ? _c('b', [_vm._v("\n                Client Name : " + _vm._s(row11.item.exporter) + "\n                "), _c('br')]) : _vm._e(), _vm._v(" "), (row11.item.clientType == '3') ? _c('b', [_vm._v("\n                Overseas Agent : " + _vm._s(row11.item.TPTClient) + "\n                "), _c('br')]) : _vm._e(), _vm._v(" "), (row11.item.clientType != '3') ? _c('b', [_vm._v("\n                " + _vm._s(row11.item.TPTClient) + "\n                "), _c('br')]) : _vm._e()]
      }
    }, {
      key: "containerNo",
      fn: function(row15) {
        return [(row15.item.containerNo) ? _c('div', [_c('h6', [_c('b-badge', {
          attrs: {
            "variant": "light"
          }
        }, [_vm._v(_vm._s(row15.item.containerNo + " / " + row15.item.containerType) + "\n                  ")])], 1)]) : _c('span', [_vm._v("-----------")])]
      }
    }, {
      key: "TEUS",
      fn: function(row151) {
        return [(row151.item.TEUS_Type) ? _c('h6', [_c('b-badge', {
          attrs: {
            "variant": "light"
          }
        }, [_vm._v(_vm._s(row151.item.TEUS_Type) + " ")])], 1) : _vm._e()]
      }
    }, {
      key: "shipperInv",
      fn: function(row150) {
        return [(row150.item.shipperInv) ? _c('div', _vm._l((row150.item.shipperInv.split(',')), function(item2, index) {
          return _c('span', {
            key: index
          }, [_c('h6', [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(item2 == "" ? "-------" : item2) + "\n                    ")])], 1)])
        })) : _c('span', [_vm._v("-----------")])]
      }
    }, {
      key: "ShippingB",
      fn: function(row100) {
        return [(row100.item.ShippingB) ? _c('div', _vm._l((row100.item.ShippingB.split(',')), function(item3, index) {
          return _c('span', {
            key: index
          }, [_c('h6', [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(item3 == "" ? "-------" : item3) + "\n                    ")])], 1)])
        })) : _c('span', [_vm._v("-----------")])]
      }
    }, {
      key: "billingSeries",
      fn: function(row1000) {
        return [(row1000.item.billingSeries) ? _c('div', _vm._l((row1000.item.billingSeries.split(',')), function(item3, index) {
          return _c('span', {
            key: index
          }, [_c('h6', [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(item3 == "" ? "-------" : item3) + "\n                    ")])], 1)])
        })) : _c('span', [_vm._v("-----------")]), _vm._v(" "), _c('Add-Message', {
          staticStyle: {
            "list-style-type": "none"
          },
          attrs: {
            "fk_all_module_id": row1000.item.allModuleId
          }
        })]
      }
    }])
  })], 1)]), _vm._v(" "), _c('div', [_c('b-pagination', {
    attrs: {
      "limit": "25",
      "align": "center",
      "per-page": _vm.perPage,
      "total-rows": _vm.totalRows
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('b-modal', {
    ref: "doc-modal",
    staticClass: "modal-dialog-doc",
    attrs: {
      "size": "xl",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": "",
      "title": ""
    }
  }, [(_vm.ALLMODULE) ? _c('div', [_c('doc-form', {
    attrs: {
      "allModuleIdProp": _vm.ALLMODULE,
      "JOBSERIES": _vm.JOBSERIES
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "outline-danger",
      "block": ""
    },
    on: {
      "click": _vm.hideDocModal
    }
  }, [_vm._v("Close\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62a03572","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/allModuleForm/viewReports.vue
// module id = 2682
// module chunks = 0